import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const DeliveryTab = styled.div<{ selected: boolean }>`
  padding: 12px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  cursor: pointer;
  gap: 4px;
  transition: all 0.2s ease-in-out;

  ${theme.typography.labelRegular}

  background-color: ${theme.color.background.primary};
  color: ${({ selected }) =>
    selected ? theme.color.text.primary : theme.color.text.tertiary};

  border-bottom: 2px solid
    ${({ selected }) =>
      selected ? theme.color.border.selected : theme.color.border.divider};

  svg {
    width: 16px;
    height: 16px;
    color: inherit;
  }
`;

export const FooterWrapper = styled.div`
  padding: 12px 20px 24px;
  @media (min-width: ${breakpoints.md}) {
    padding: 12px 20px;
  }
`;

export const LegalInfo = styled.div`
  background: ${theme.color.background.secondary};
  padding: 13px;
  display: flex;
  gap: 8px;
  color: ${theme.color.text.secondary};
  ${theme.typography.labelSmall400}

  svg {
    color: ${theme.color.icon.tertiary};
    min-width: 16px;
    height: 16px;
  }
`;

export const DeliveryItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 20px;

  border-bottom: 1px solid ${theme.color.border.divider};

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  svg {
    width: 18px;
    min-width: 18px;
    height: 18px;
  }
`;

export const DeliveryDescription = styled.div`
  font-size: 14px;
`;
